import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import 'jspdf-autotable';
import { AuthService } from 'app/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { RepaymentsService } from './../../../services/repayments.service';

@Component({
  selector: 'app-repayment-by-borrower',
  templateUrl: './repayment-by-borrower.component.html',
  styleUrls: ['./repayment-by-borrower.component.css'],
})
export class RepaymentByBorrowerComponent implements OnInit {
  user: any;
  p: number = 1;
  itemsPerPage = 10;
  currentPage = 1;
  lApplications: Array<any> = [];
  dataRec: Boolean = false;
  dataToShow: Array<any> = [];
  appObj: any;
  filterWnameArr: Array<any> = [];
  fromDate: any;
  toDate: any;
  loanAppsLoaded: Boolean = false;
  isFilterSet: boolean = false;
  valMsgRS: boolean = false;

  constructor(
    private lservice: RepaymentsService,
    private router: Router,
    private auth: AuthService,
    private toastr: ToastrService // private ngxLoader: NgxUiLoaderService
  ) {}

  ngOnInit() {
    let obj = {
      limit: 2,
      fromDate: this.fromDate,
      toDate: this.toDate,
      type: 'by-date',
    };

    // this.ngxLoader.start();
    this.loanAppsLoaded = false;
    this.lservice.RepaymentbyBorrower(obj).subscribe((data) => {
      this.dataRec = true;
      this.loanAppsLoaded = true;
      if (data['success']) {
        this.lApplications = data['data'];
        this.dataToShow = data['data'];
        for (let i = 0; i < this.dataToShow.length; i++) {
          // this.dataToShow[i]['tprice'] = this.dataToShow[i]['depositQuantity'].match(/\d+/g) * this.dataToShow[i]['depositApp']['perUnitValue'];
          this.dataToShow[i]['tprice'] =
            this.dataToShow[i]['depositApp']['depositQty'] *
            this.dataToShow[i]['depositApp']['perUnitValue'];
          if (
            !this.isInArray(
              this.lApplications[i]['warehouseName'],
              this.filterWnameArr
            )
          ) {
            this.filterWnameArr.push(this.lApplications[i]['warehouseName']);
          }
        }
        // this.ngxLoader.stop();
      }
    });
  }

  isInArray(value, array) {
    return array.indexOf(value) > -1;
  }

  filterByDate() {}

  removeFilter() {}
}
